import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "label" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import http from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';

interface SupPullDown {
  label: string;
  value: string;
}

interface Props {
  // サプライヤコード
  suppliers: SupPullDown[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierSelectsUseInput',
  props: {
    suppliers: {}
  },
  emits: ['clear', 'change'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();

// サプライヤ
const suppliersComputed = computed({
  get: () => props.suppliers,
  set: (value) => {
    emit('change', value);
  },
});

// クリア
const clear = () => {
  emit('clear', []);
};

// サプライヤプルダウンリスト
const stringOptions = ref<SupPullDown[]>([]);

// サプライヤ（フィルター用）
const options = ref(stringOptions.value);

// サプライヤ取得
const getSuppliers = () => {
  http
    .post('/suppliers')
    .then((response) => {
      if (response.data.common.status === ResultStatusCode.ERROR) {
        // システムエラー
        router.push({ name: 'error' });
      }
      response.data.supplierSelectItems.forEach(
        (supplier: { supplier_name: string; supplier_code: string }) => {
          stringOptions.value.push({
            label: `${supplier.supplier_code}: ${supplier.supplier_name}`,
            value: supplier.supplier_code,
          });
        }
      );
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    });
};

// プルダウンフィルター
const filterFn = (val: string, update: (arg0: () => void) => void) => {
  update(() => {
    if (val === '') {
      options.value = stringOptions.value;
    } else {
      const needle = val.toLowerCase();
      options.value = stringOptions.value.filter(
        (v: { label: string; value: string }) =>
          v.label.toLowerCase().indexOf(needle) > -1 || v.value.toLowerCase().indexOf(needle) > -1
      );
    }
  });
};

// 初期表示処理
getSuppliers();

return (_ctx: any,_cache: any) => {
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    modelValue: suppliersComputed.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((suppliersComputed).value = $event)),
    name: "supplier",
    clearable: "",
    "use-input": "",
    multiple: "",
    outlined: "",
    dense: "",
    "input-debounce": "0",
    class: "supplier-select-useinput",
    options: options.value
  }, suppliersComputed.value.length === 0 && { placeholder: '選択してください（複数選択可）' }, {
    onClear: clear,
    onFilter: filterFn
  }), {
    selected: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suppliersComputed.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createVNode(_component_q_chip, {
            removable: "",
            color: "secondary",
            "text-color": "dark",
            class: "q-my-xs q-ml-xs q-mr-none",
            onRemove: ($event: any) => (suppliersComputed.value.splice(index, 1))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["onRemove"])
        ]))
      }), 128))
    ]),
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" 該当するサプライヤはありません ")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["modelValue", "options"]))
}
}

})